import { render, staticRenderFns } from "./SignatureDB.vue?vue&type=template&id=92d3b50e&scoped=true"
import script from "./SignatureDB.vue?vue&type=script&lang=js"
export * from "./SignatureDB.vue?vue&type=script&lang=js"
import style0 from "./SignatureDB.vue?vue&type=style&index=0&id=92d3b50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3b50e",
  null
  
)

export default component.exports